import * as React from "react";
import { observer, inject } from "mobx-react";
import { hashHistory } from "react-router";
import SeekerStore from "../../stores/seekerStore";
import { Demographics } from "../../models/profile";
import { IDemographicsLocalization } from "../../models/localization";
import { Grid, Row, Col } from "react-flexbox-grid";
import BackButton from "../../components/widgets/backBtn";

@inject("store") @observer
export default class NotificationsVw extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }
  render(): JSX.Element {
    if (!this.props.store.profileStore.profile) {
      return null;
    }
    return (
      <Grid>
        <BackButton />
        <Row>
          <Col xs={12}>
            <h3>Notifications</h3>
            <div>This may be tabled if we don't implement notifications for the initial release but put in the placeholder just in case</div>
          </Col>
        </Row>
      </Grid>
    );
  }
}


// WEBPACK FOOTER //
// ./src/views/notifications/index.tsx